import { Metadata_StringCategory$reflection, Metadata_StringCategory } from "../../../../Shared/Shared.js";
import { class_type } from "../../../../fable_modules/fable-library.3.7.9/Reflection.js";

export class Tid extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "tid";
    }
}

export function Tid$reflection() {
    return class_type("Corpora.Digsos.MetadataCategories.Tid", void 0, Tid, Metadata_StringCategory$reflection());
}

export function Tid_$ctor_Z721C83C5(aName) {
    return new Tid(aName);
}

export class Region extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "region";
    }
}

export function Region$reflection() {
    return class_type("Corpora.Digsos.MetadataCategories.Region", void 0, Region, Metadata_StringCategory$reflection());
}

export function Region_$ctor_Z721C83C5(aName) {
    return new Region(aName);
}

export class BirthYear extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "birth_year";
    }
}

export function BirthYear$reflection() {
    return class_type("Corpora.Digsos.MetadataCategories.BirthYear", void 0, BirthYear, Metadata_StringCategory$reflection());
}

export function BirthYear_$ctor_Z721C83C5(aName) {
    return new BirthYear(aName);
}

export class Gender extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "gender";
    }
}

export function Gender$reflection() {
    return class_type("Corpora.Digsos.MetadataCategories.Gender", void 0, Gender, Metadata_StringCategory$reflection());
}

export function Gender_$ctor_Z721C83C5(aName) {
    return new Gender(aName);
}

export class GrownUpLocally extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "grown_up_locally";
    }
}

export function GrownUpLocally$reflection() {
    return class_type("Corpora.Digsos.MetadataCategories.GrownUpLocally", void 0, GrownUpLocally, Metadata_StringCategory$reflection());
}

export function GrownUpLocally_$ctor_Z721C83C5(aName) {
    return new GrownUpLocally(aName);
}

export class LivedOutsideLocalArea extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "lived_outside_local_area";
    }
}

export function LivedOutsideLocalArea$reflection() {
    return class_type("Corpora.Digsos.MetadataCategories.LivedOutsideLocalArea", void 0, LivedOutsideLocalArea, Metadata_StringCategory$reflection());
}

export function LivedOutsideLocalArea_$ctor_Z721C83C5(aName) {
    return new LivedOutsideLocalArea(aName);
}

export class HigherEducation extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "higher_education";
    }
}

export function HigherEducation$reflection() {
    return class_type("Corpora.Digsos.MetadataCategories.HigherEducation", void 0, HigherEducation, Metadata_StringCategory$reflection());
}

export function HigherEducation_$ctor_Z721C83C5(aName) {
    return new HigherEducation(aName);
}

export class MotherTongue extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "mother_tongue";
    }
}

export function MotherTongue$reflection() {
    return class_type("Corpora.Digsos.MetadataCategories.MotherTongue", void 0, MotherTongue, Metadata_StringCategory$reflection());
}

export function MotherTongue_$ctor_Z721C83C5(aName) {
    return new MotherTongue(aName);
}

export class NumLanguages extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "num_languages";
    }
}

export function NumLanguages$reflection() {
    return class_type("Corpora.Digsos.MetadataCategories.NumLanguages", void 0, NumLanguages, Metadata_StringCategory$reflection());
}

export function NumLanguages_$ctor_Z721C83C5(aName) {
    return new NumLanguages(aName);
}

export class LangFriends extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "lang_friends_name";
    }
    ["Shared.Metadata.Category.get_TableName"]() {
        return "lang_friends";
    }
}

export function LangFriends$reflection() {
    return class_type("Corpora.Digsos.MetadataCategories.LangFriends", void 0, LangFriends, Metadata_StringCategory$reflection());
}

export function LangFriends_$ctor_Z721C83C5(aName) {
    return new LangFriends(aName);
}

export class LangHome extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "lang_home_name";
    }
    ["Shared.Metadata.Category.get_TableName"]() {
        return "lang_home";
    }
}

export function LangHome$reflection() {
    return class_type("Corpora.Digsos.MetadataCategories.LangHome", void 0, LangHome, Metadata_StringCategory$reflection());
}

export function LangHome_$ctor_Z721C83C5(aName) {
    return new LangHome(aName);
}

export class LangSchool extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "lang_school_name";
    }
    ["Shared.Metadata.Category.get_TableName"]() {
        return "lang_school";
    }
}

export function LangSchool$reflection() {
    return class_type("Corpora.Digsos.MetadataCategories.LangSchool", void 0, LangSchool, Metadata_StringCategory$reflection());
}

export function LangSchool_$ctor_Z721C83C5(aName) {
    return new LangSchool(aName);
}

export class WrittenLang extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "written_lang";
    }
}

export function WrittenLang$reflection() {
    return class_type("Corpora.Digsos.MetadataCategories.WrittenLang", void 0, WrittenLang, Metadata_StringCategory$reflection());
}

export function WrittenLang_$ctor_Z721C83C5(aName) {
    return new WrittenLang(aName);
}

export class ChangedWrittenLang extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "changed_written_lang";
    }
}

export function ChangedWrittenLang$reflection() {
    return class_type("Corpora.Digsos.MetadataCategories.ChangedWrittenLang", void 0, ChangedWrittenLang, Metadata_StringCategory$reflection());
}

export function ChangedWrittenLang_$ctor_Z721C83C5(aName) {
    return new ChangedWrittenLang(aName);
}

